"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLoginMutation = exports.authApi = void 0;
// api/authApi.ts
var react_1 = require("@reduxjs/toolkit/query/react");
var baseQueryWithReauth_1 = require("../../utils/baseQueryWithReauth");
exports.authApi = (0, react_1.createApi)({
    reducerPath: "authApi",
    baseQuery: (0, baseQueryWithReauth_1.baseQueryWithReauth)(process.env.AUTH_API),
    tagTypes: ["auth"],
    endpoints: function (builder) { return ({
        login: builder.mutation({
            query: function (obj) { return ({
                url: "/v1/admin/log-in",
                method: "POST",
                body: obj,
            }); },
            invalidatesTags: ["auth"],
        }),
    }); },
});
exports.useLoginMutation = exports.authApi.useLoginMutation;
